import subscriptionPricing from '@budgit/subscription-pricing';

// Stripe configuration using only environment variables
const stripeConfig = {
  PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  PRICES: {
    PREMIUM_MONTHLY: process.env.REACT_APP_STRIPE_PREMIUM_MONTHLY_PRICE_ID,
    PREMIUM_YEARLY: process.env.REACT_APP_STRIPE_PREMIUM_YEARLY_PRICE_ID,
  },
};

const config = {
  // In production, uses relative URL (/api/v1) so the same bundle works on both budgit.app and admin.budgit.app
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:4001/api/v1',
  
  // Add Plaid configuration
  PLAID: {
    ENV: process.env.REACT_APP_PLAID_ENV || 'sandbox',
    CLIENT_NAME: process.env.REACT_APP_PLAID_CLIENT_NAME || 'budgit',
    PRODUCTS: (process.env.REACT_APP_PLAID_PRODUCTS || 'transactions').split(','),
    COUNTRY_CODES: (process.env.REACT_APP_PLAID_COUNTRY_CODES || 'US').split(','),
    LANGUAGE: process.env.REACT_APP_PLAID_LANGUAGE || 'en',
  },

  // Add Stripe configuration
  STRIPE: stripeConfig,
  // Display-only. Dollar amounts come from shared/subscription-pricing.js
  // (the same cents as the app). No env override: a build-time display env
  // was how a stale Apple price could ship without a code change.
  PRICING_DISPLAY: {
    APPLE_FOUNDER_MONTHLY: subscriptionPricing.APPLE_MONTHLY_USD,
    PREMIUM_FOUNDER_MONTHLY: subscriptionPricing.STRIPE_MONTHLY_USD,
  },
  // Web founding price is open to anyone who joins before this date.
  FOUNDING_MEMBER_DEADLINE: process.env.REACT_APP_FOUNDING_MEMBER_DEADLINE || 'April 1, 2027',

  // App Store campaign pt. Public in the bundle. #2450 replaces this env read
  // with the admin tracking config. Callers use readAppStoreProviderToken().
  get APP_STORE_PROVIDER_TOKEN() {
    return process.env.REACT_APP_APP_STORE_PROVIDER_TOKEN || '';
  },

  // LinkedIn Insight Tag partner id and conversion ids (#2445). Public in the
  // bundle. Set from DigitalOcean env at build time; every value unset means
  // the tag stays off. Callers use getLinkedInInsightIds(), not these keys.
  get LINKEDIN() {
    return {
      PARTNER_ID: process.env.REACT_APP_LINKEDIN_PARTNER_ID || '',
      CONV_SIGNUP: process.env.REACT_APP_LINKEDIN_CONV_SIGNUP || '',
      CONV_STORE_CLICK: process.env.REACT_APP_LINKEDIN_CONV_STORE_CLICK || '',
      CONV_CHECKOUT: process.env.REACT_APP_LINKEDIN_CONV_CHECKOUT || '',
    };
  },

  // X (Twitter) ads pixel id (#2437), e.g. `r3zmh`. Public in the bundle.
  // Set from DigitalOcean env at build time; unset means the pixel stays off.
  // Callers use getXAdsPixelIds(), not this key.
  get X_PIXEL_ID() {
    return process.env.REACT_APP_X_PIXEL_ID || '';
  },

  // Meta Pixel id (#2442), digits only. Public in the bundle. Set from
  // DigitalOcean env at build time; unset (or not all digits) means the
  // pixel stays off. Callers use getMetaPixelId(), not this key.
  get META_PIXEL_ID() {
    return process.env.REACT_APP_META_PIXEL_ID || '';
  },
};

export default config;
